module.exports = __webpack_public_path__ + "img/details6.44b837ac.png";